export const URL_USER_BASE = "https://bk.databiomsci.com/api/users/v1/";
export const URL_BACKENDS_BASE = "https://bk.databiomsci.com/api/backends/v1/";
export const URL_DATA_MANAGEMENT_BASE = "https://bk.databiomsci.com/api/data_management/v1/";
export const URL_DATA_EXPORT_BASE = "https://bk.databiomsci.com/api/data_export/v1/";
